import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AddLastPageRoutingModule } from './add-last-routing.module';

import { AddLastPage } from './add-last.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AddLastPageRoutingModule,
    TranslateModule
  ],
  declarations: [AddLastPage]
})
export class AddLastPageModule {}
